import alert from '@/plugins/alert'
import { AssetRepairRequest, AssetMaintenanceSchedule } from '@/plugins/api'
import { rangeRight } from 'lodash'

export default {
  namespaced: true,
  state: {
    loading: false,
    pageText: '',
    itemsPerPage: 10,
    repairSearchParams: {},
    totalRepairs: 0,
    repairs: [],
    schedules: []
  },
  actions: {
    async searchRepairList({ commit, state, dispatch }, query) {
      const repairSearchParams = {
        isDelete: false,
        _limit: state.itemsPerPage,
        ...query
      }
      commit('changeState', { repairSearchParams })
      dispatch('requestPageSettings', {})
    },

    async requestPageSettings({ state, commit, dispatch }, { page, itemsPerPage }) {
      commit('changeState', { loading: true })
      if (!page) page = 1
      if (!itemsPerPage) itemsPerPage = state.itemsPerPage

      if (state.repairSearchParams) {
        const repairSearchParams = {
          ...state.repairSearchParams,
          isDelete: false,
          _start: (page - 1) * itemsPerPage,
          _limit: itemsPerPage,
          _sort: 'createdAt:DESC'
        }

        const [totalRepairs, repairs, schedules] = await Promise.all([
          AssetRepairRequest.count(repairSearchParams),
          AssetRepairRequest.search(repairSearchParams),
          AssetMaintenanceSchedule.search({ isDelete: false, _limit: -1 })
        ])

        if (totalRepairs > (page - 1) * itemsPerPage || page === 1) {
          commit('changeState', {
            repairs,
            schedules,
            totalRepairs,
            itemsPerPage,
            repairSearchParams
          })
          const pageStart = (page - 1) * itemsPerPage + 1
          let pageStop = page * itemsPerPage
          pageStop = pageStop > totalRepairs || pageStop === -1 ? totalRepairs : pageStop
          const pageText = `${pageStart}-${pageStop} trên ${totalRepairs}`
          commit('setPageText', pageText)
        } else {
          const pages = rangeRight(1, page)
          for (let index = 0; index < pages.length; index++) {
            const selectedPage = pages[index]
            if (totalRepairs > (selectedPage - 1) * itemsPerPage) {
              dispatch('requestPageSettings', {})
              break
            }
          }
        }
      }
      commit('changeState', { loading: false })
    },

    async createRepair({ commit, state }, payload) {
      try {
        const created = await AssetRepairRequest.create(payload)
        commit('changeState', {
          repairs: [created, ...state.repairs]
        })
        alert.success('Tạo phiếu báo hỏng thành công')
        return created
      } catch (e) {
        alert.error(e)
      }
    },

    async updateRepair({ commit }, { id, ...data }) {
      try {
        const updated = await AssetRepairRequest.update(id, data)
        commit('updateRepair', updated)
        alert.success('Cập nhật sửa chữa thành công')
        return updated
      } catch (e) {
        alert.error(e)
      }
    },

    async createSchedule({ commit, state }, payload) {
      try {
        const created = await AssetMaintenanceSchedule.create(payload)
        commit('changeState', {
          schedules: [created, ...state.schedules]
        })
        alert.success('Tạo lịch bảo dưỡng thành công')
        return created
      } catch (e) {
        alert.error(e)
      }
    }
  },
  mutations: {
    setPageText(state, pageText) {
      state.pageText = pageText
    },
    updateRepair(state, data) {
      state.repairs = state.repairs.map(r => (r.id === data.id ? data : r))
    },
    changeState(state, payload) {
      Object.assign(state, payload)
    }
  }
}
